import { RR_BLACK, RR_WHITE } from '../constants/colors';

export const RRContrastColor = (textColor: string) => {
  const hexcolor = textColor.replace('#', '');
  const r = parseInt(hexcolor.substring(0, 2), 16);
  const g = parseInt(hexcolor.substring(2, 2), 16);
  const b = parseInt(hexcolor.substring(4, 2), 16);

  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  return yiq >= 128 ? RR_BLACK : RR_WHITE;
};
